import {RequestedTicketTimelineEvent} from '@ots-frontend/ots-data';
import {Text} from '@mantine/core'
import {useTranslation} from "react-i18next";
import {FormattedDateTime} from '../../date/FormattedDateTime/FormattedDateTime';
import {IconAsterisk} from "@tabler/icons-react";

type Props = {
  event: RequestedTicketTimelineEvent;
};

export const RequestedTimelineItemTitle = (props: {}) => {
  const {t} = useTranslation(["common"])
  return <>{t("common.entity.transporttransportassoc.timeline.requested.title", "Requested")}</>
}

export const RequestedTimelineItemBullet = (props: {}) => {
  return (
    <IconAsterisk size={12}/>
  )
}

export const RequestedTimelineItem = (props: Props) => {
  const {event} = props;

  const {t} = useTranslation(["common"])

  return (
    <>
      <Text color="dimmed" size="sm">
        {t("common.entity.dispatch.timeline.requested.summary", "{{personName}} requested a dispatch.", {
          personName: event.person ? event.person : t("common.shared.user", "User"),
        })}
      </Text>

      <Text size="xs" mt={4}>
        <FormattedDateTime date={event.date}/>
      </Text>
    </>
  );
};

RequestedTimelineItem.Title = RequestedTimelineItemTitle
RequestedTimelineItem.Bullet = RequestedTimelineItemBullet;
